<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 10.9331V7.81641" stroke="#F4AC33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M9.99921 13.4368C9.88421 13.4368 9.79088 13.5302 9.79171 13.6452C9.79171 13.7602 9.88504 13.8535 10 13.8535C10.115 13.8535 10.2084 13.7602 10.2084 13.6452C10.2084 13.5302 10.115 13.4368 9.99921 13.4368"
      stroke="#F4AC33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M11.6908 3.44867L18.0733 14.6187C18.815 15.917 17.8775 17.5328 16.3825 17.5328H3.61751C2.12167 17.5328 1.18417 15.917 1.92667 14.6187L8.30917 3.44867C9.05667 2.13951 10.9433 2.13951 11.6908 3.44867Z"
      stroke="#F4AC33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
<script setup lang="ts" />